/* eslint-disable import/prefer-default-export */

const URL = 'https://geolocation-db.com/json/';
export class IPManager {
  static getMyIp = (setIpValue: any) => {
    fetch(URL)
      .then((response) => {
        return response.json();
      })
      .then((res: any) => {
        setIpValue(res.IPv4);
      })
      .catch(() => {
        setIpValue('none');
      });
  };
}
